import { Component } from '@angular/core';
import { Route } from '../../utils/route';
import { TabsComponent } from "../../components/tabs/tabs.component";
import { SamplesTabComponent } from "./samples-tab/samples-tab.component";

@Component({
  selector: 'app-samples',
  imports: [TabsComponent, SamplesTabComponent],
  templateUrl: './samples.component.html',
  styleUrl: './samples.component.scss',
})
export class SamplesComponent extends Route {}
